/* eslint-disable import/order */
import { MenuIdPlans } from '@jira/navigation-apps__constants/src/MenuIdPlans.tsx';
import {
	advancedRoadmapsPlanPageInitialChecksResource,
	advancedRoadmapsReduxStoreStateResource,
} from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanPageInitialChecksResource.tsx';
import { getPlansBacklogResource } from '@jira/router-resources__advanced-roadmaps-plan/src/plansBacklogResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { planLayout } from '@jira/platform__layouts-jira-plan-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { composeLayouts } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import {
	getNavigationResources,
	getNavigationSidebarPlanResources,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { planIncrementRoute } from '@jira/router-routes__advanced-roadmaps-spa-routes/src/planIncrementRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { planIncrementPageEntryPoint } from './ui/plan-increment/index.tsx';
import { PlanIncrement, LazyPlanIncrement } from './ui/plan-increment/index-old.tsx';

// "Increment" board page
export const planIncrementRouteEntry: Route = createEntry(planIncrementRoute, () => ({
	group: 'software',
	entryPoint: () => planIncrementPageEntryPoint,
	// eslint-disable-next-line no-restricted-syntax
	component: PlanIncrement,
	layout: composeLayouts(globalLayout, planLayout),

	navigation: {
		menuId: MenuIdPlans,
	},

	preloadOptions: {
		earlyChunks: ['advanced-roadmaps-early-entry'],
	},

	resources: [
		...getNavigationResources(),
		...getNavigationSidebarPlanResources(),
		advancedRoadmapsPlanPageInitialChecksResource,
		...getPlansBacklogResource(),
		advancedRoadmapsReduxStoreStateResource,
	],

	forPaint: [LazyAtlassianNavigation, LazyPlanIncrement],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
